
























































































import api from '@/services/api';
import { Component, Vue, Prop } from 'vue-property-decorator';
import ReleaseNote from '@/classes/ReleaseNote';
import WYSIWYG from '@/components/WYSIWYG.vue';

@Component({
    components: {
        WYSIWYG
    }
})
export default class ReleaseNoteForm extends Vue {
    public form: ReleaseNote = new ReleaseNote();
    @Prop({default: false}) public edit?: boolean;
    @Prop({default: false}) public view?: boolean;
    @Prop() public id!: number;

    public mounted() {
        if (this.id) {
            this.updateForm();
        }
    }

    public updateForm() {
        if (this.id !== undefined && !isNaN(this.id)) {
            this.$store.dispatch('notifications/loadReleaseNotes', true)
            .then(() => {
                const foundForm: ReleaseNote | null = this.$store.getters['notifications/getReleaseNoteById'](this.id);
                if ( foundForm !== null) {
                    this.form = foundForm;
                } else {
                    alert('Release note not found.');
                    this.$router.push('/administration/releasenotes');
                }
            });
        }
    }

    public submit(): void {
        const dispatchString: string = this.edit ? 'notifications/editReleaseNote' : 'notifications/addReleaseNote';
        this.$store.dispatch(dispatchString, this.form)
        .catch(() => {
            alert('There was an issue performing this action.');
            this.$router.push('/administration/releasenotes');
        });
    }

    public deleteNotification(): void {
        this.$store.dispatch('notifications/deleteReleaseNote', this.form)
        .catch(() => {
            alert('There was an issue performing this action.');
            this.$router.push('/administration/releasenotes');
        });
    }

    public get cardTitle(): string {
        if (this.edit) {
            return 'Edit Release Note';
        } else if (this.view) {
            return 'View Release Note';
        } else {
            return 'New Release Note';
        }
    }

    public getUserProfileName(id: number) {
        const user = this.$store.getters.getUserProfileById(id);
        if (user) {
        return user.getFullName();
        } else {
        return '';
        }
    }
}
